import React, { useState, useEffect } from 'react';
import CustomButton from '../elements/Buttons';
import '../styles/_globals.scss';

import ActiveFilterBanner from './Filters/ActiveFiltersBanner';
import TranslationLabel from './TranslationLabel';
import infoIconGreen from '../assets/images/info-icon-green.svg';

import { selectedYear, changeYearByAmount,setDisplayYear } from '../redux/yearSlice.jsx';
import Dropdown from "react-bootstrap/Dropdown";
import { useDispatch, useSelector } from 'react-redux';
import { selectedQuestion, setSelectedQuestionV, setHasResponse } from '../redux/QuestionsSlice.jsx';


var request = require('sync-request');



export default function Header() {
    const [modalShow, setModalShow] = useState(false);
    const [toggle, setToggle] = useState(false);
    

    const year = useSelector(state => state.selectedYear.year);    
    const hasResponse = useSelector(state => state.questions.hasResponse);
    
    const displayYear = useSelector(state => state.selectedYear.displayYear); 

    const dispatch = useDispatch();

    const dropDrownToggle = () => {
        setToggle(prevCheck => !prevCheck);
    }
    const handleClose = () => {
        setModalShow(false);
    };

    const handleYear = async (e, yr, questV) => {
        console.log(yr.toLowerCase());
        switch (yr.toLowerCase()) {
            case "2022":
                console.log('case 1');
               await dispatch(setDisplayYear('2022'))
              break;
            case '2021db':
                console.log('case 2');
                await dispatch(setDisplayYear('2021'))
              break;    
              case '2020a':                
                await dispatch(setDisplayYear('2020'))
              break; 
              case '2020b':              
                await dispatch(setDisplayYear('2020'))
              break;  
              case '2019':              
                await dispatch(setDisplayYear('2019'))
              break;        
            case '2018db':                
                await dispatch(setDisplayYear('2018'))
              break;            
          }
        try{
            await dispatch(setSelectedQuestionV(questV))
            await dispatch(changeYearByAmount(yr))
          
        }
       catch(err){

       }
        // console.log(yr.toLowerCase());
        // console.log(year);
        // console.log(displayYear);
        setToggle(false)
    }

    return (
        <>
            <div className="gradient header-font header ">
                <div className="header-title">

                {true ? 
                    <TranslationLabel id="label_02" defaultValue={"Explore the " +  displayYear  + " Survey Data"} />
                    : "Explore the " +  displayYear + " Survey Data" }

                    <div className='year-select1' style={{ marginLeft: '20px', fontSize: '15px', alignItems: 'center' }} >
                        <div className='year-dropdown' name="year" required onChange={handleYear} style={toggle ? { color: 'purple' } : { color: 'rgb(167, 226, 6)' }}>
                            <div className='year-dropdown-toggle' onClick={dropDrownToggle}>
                            <TranslationLabel id="label_29" defaultValue={"Change Year"} />
                                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-caret-down-fill year-arrow" viewBox="0 0 16 16">
                                    <path d="M7.247 11.14 2.451 5.658C1.885 5.013 2.345 4 3.204 4h9.592a1 1 0 0 1 .753 1.659l-4.796 5.48a1 1 0 0 1-1.506 0z" />
                                </svg>
                            </div>
                            <div className='year-dropdown-container' style={toggle ? { maxHeight: '100%' } : { maxHeight: '0' }} >
                                <div className='year-select-year' onClick={((e) => handleYear(e, '2022', 'Q11'))} value="2022">2022</div>
                                <div className='year-select-year' onClick={((e) => handleYear(e, '2021db', 'Q1_W5'))} value="2021">2021</div>
                                <div className='year-select-year' onClick={((e) => handleYear(e, '2020b', 'Q11'))} value="2020">2020 Pandemic Pulse</div>
                                <div className='year-select-year' onClick={((e) => handleYear(e, '2020a', 'Q4_W2'))} value="2020">2020 Pre Pandemic</div>
                                <div className='year-select-year' onClick={((e) => handleYear(e, '2019', 'Q1_W2'))} value="2019">2019</div>
                                <div className='year-select-year' onClick={((e) => handleYear(e, '2018db', 'Q2'))} value="2018">2018</div>
                            </div>
                        </div>
                    </div>
                </div>


                <div className="about mb-2 mt-2 align-self-start">
                    <CustomButton
                        className="text-right"
                        onClick={() => setModalShow(!modalShow)}
                        src={infoIconGreen}
                        alt={'information icon'}
                        backgroundColor={'#1E1E96'}
                        text_align={'text-center'}
                    >
                        <TranslationLabel id="label_03" defaultValue="About the Data Explorer" />
                    </CustomButton>
                </div>
                {modalShow ? (
                    <div
                        style={{
                            position: 'absolute',
                            zIndex: 1200,
                            height: '100%',
                            width: '100%',
                            top: '0',
                            left: '0',
                            borderRadius: '1px',
                            color: '#4F4F4F',
                            backgroundColor: 'rgba(0,0,0,.8)',
                            border: '4px solid #ECDCD',
                        }}
                    >
                        <div className="modal-content" style={{
                            position: 'absolute',
                            zIndex: 1200,
                            height: '50%',
                            width: '50%',
                            left: '25%',
                            top: '25%',
                            borderRadius: '1px',
                            color: '#4F4F4F',
                            backgroundColor: '#ffffff',
                            border: '4px solid #ECDCD',
                        }}>
                            <div className="close-modal" onClick={handleClose}>
                                X
                            </div>
                            <div className="modal-header">
                                <h4 className="modal-title">
                                    <TranslationLabel id="label_03" defaultValue="About the Data Explorer" />
                                </h4>
                            </div>
                            <div className="modal-body">
                                <h6>
                                    <TranslationLabel id="label_04" />
                                </h6>
                            </div>
                        </div>
                    </div>
                ) : null}
            </div>
            <ActiveFilterBanner />
        </>
    );
}
